import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";
import "moment-timezone";
import DateTimesUtils from "core/utils/DateTimesUtils";

const TableProgramming = ({itemsShow}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Td} = useTranslation("datestimes");
    const {t: _Tt} = useTranslation("tables");

    const translateValues = (item) => {
        let title = "";
        switch (item.repeat) {
            case "w":
                let day;
                let days = [];
                for (day of item.values.days) {
                    days.push(_Td("days." + day));
                }
                title += days.join(", ");
                break;
            case "m":
                switch (item.values.type) {
                    case "d":
                        title = "Dia " + item.values.day + " de cada mes";
                        break;
                    case "n":
                        title =
                            _Td("the_place." + item.values.value) + " " + _Td("days_name." + item.values.day) + " de cada mes";
                        break;
                    case "p":
                        title =
                            _Td("the_place." + item.values.value) + " " + _Td("days_name." + item.values.day) + " de cada mes";
                        break;
                    default:
                }
                break;
            case "y":
                switch (item.values.type) {
                    case "d":
                        title = "Dia " + item.values.day + " de " + _Td("months_name." + item.values.value);
                        break;
                    case "n":
                        title =
                            _Td("the_place." + item.values.place) +
                            " " +
                            _Td("days_name." + item.values.day) +
                            " de " +
                            _Td("months_name." + item.values.value);
                        break;
                    case "p":
                        title =
                            _Td("the_place." + item.values.place) +
                            " " +
                            _Td("days_name." + item.values.day) +
                            " de " +
                            _Td("months_name." + item.values.value);
                        break;
                    default:
                }
                break;
            default:
                break;
        }
        return title;
    };

    return (
        <table className="table table-striped table-sticky-horizontal" style={{fontSize: "1rem"}}>
            <thead>
                <tr>
                    <th>
                        {_Tt("common.name")} <br /> {_Tt("common.start")}, {_Tt("common.end")}
                    </th>
                    <th>
                        {_Tt("common.type")} <br /> {_Tt("common.compile")} / {_Tt("common.start_hour")}
                    </th>
                    <th>{_Tt("common.repeat")}</th>
                    <th>{_Tt("common.between")}</th>
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id}>
                        <td>
                            {item.name}
                            <br />
                            {item.date_start ? <DateDisplay date={item.date_start} format="DD-MM-YYYY" title={true} /> : "-"},
                            {item.date_end ? <DateDisplay date={item.date_end} format="DD-MM-YYYY" title={true} /> : "-"}
                        </td>
                        <td>
                            {_Tc("programming." + item.type)} <br />
                            {DateTimesUtils.timeToHourMinute(item.compile)} / {DateTimesUtils.timeToHourMinute(item.run)}
                        </td>
                        <td>{_Tc("repeat." + item.repeat)}</td>
                        <td>{translateValues(item)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableProgramming;
